import React, { Component } from "react";
import AthOnboardingProductsBuild from "./AthOnboardingProductsBuild";
import AthOnboardingProductsInfoWindow from "./AthOnboardingProductsInfoWindow";
import Modal from "react-responsive-modal";
import * as util from "../../../utils/util";
import "./AthOnboardingProducts.css";

import {
  answerBubbleStyle,
  answerBubbleStyleMobile
} from "../../../utils/styles";

import { MultComponentButton } from "../../../views/onboarding/OnboardingStyles";

class AthOnboardingProducts extends Component {
  constructor(props) {
    super(props);

    this.handleDone = this.handleDone.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);

    this.products = [];
    this.productCats = [];
    this.productsStr = "";

    this.state = {
      customed: null,
      finished: false,
      showInfoModal: false
    };
  }

  componentDidUpdate() {
    const touchsupport = util.isMobile(navigator.userAgent);
    const doneButton = document.querySelector(
      ".multiselect-component__image-wrapper-btn"
    );
    if (doneButton && !touchsupport) doneButton.scrollIntoView();
  }

  handleOnClick(id) {
    this.setState({ selected: id });

    if (id !== 4) {
      this.products = [];
      this.productCats = [];
      if (id === 1) {
        this.addItem({ cats: "wash,condition,dry", value: "3-Step Regimen" });
      } else if (id === 2) {
        this.addItem({
          cats: "wash,condition,dry,style",
          value: "4-Step Regimen"
        });
      } else if (id === 3) {
        this.addItem({
          cats: "wash,condition,dry,style,refresh",
          value: "5-Step Regimen"
        });
      } else if (id === 5) {
        this.addItem({
          cats: "wash,condition,dry,style,refresh",
          value: "I don't know"
        });
      }
    } else {
      let indexThreeStep = this.products.indexOf("3-Step Regimen");
      let indexThreeStepIndices = this.productCats.indexOf(
        "wash,condition,dry"
      );
      let indexFourStep = this.products.indexOf("4-Step Regimen");
      let indexFourStepIndices = this.productCats.indexOf(
        "wash,condition,dry,style"
      );
      let indexFiveStep = this.products.indexOf("5-Step Regimen");
      let indexFiveStepIndices = this.productCats.indexOf(
        "wash,condition,dry,style,refresh"
      );
      let indexDontKnow = this.products.indexOf("I don't know");
      let indexDontKnowIndices = this.productCats.indexOf(
        "wash,condition,dry,style,refresh"
      );

      if (indexThreeStep > -1 || indexThreeStepIndices > -1) {
        this.products.splice(indexThreeStep, 1);
        this.productCats.splice(indexThreeStepIndices, 1);
      } else if (indexFourStep > -1 || indexFourStepIndices > -1) {
        this.products.splice(indexFourStep, 1);
        this.productCats.splice(indexFourStepIndices, 1);
      } else if (indexFiveStep > -1 || indexFiveStepIndices > -1) {
        this.products.splice(indexFiveStep, 1);
        this.productCats.splice(indexFiveStepIndices, 1);
      } else if (indexDontKnow > -1 || indexDontKnowIndices > -1) {
        this.products.splice(indexDontKnow, 1);
        this.productCats.splice(indexDontKnowIndices, 1);
      }
    }
  }

  addItem(answer) {
    let index = this.products.indexOf(answer.value);
    if (index === -1) {
      this.products.push(answer.value);
    }
    index = this.productCats.indexOf(answer.cats);
    if (index === -1) {
      this.productCats.push(answer.cats);
    }
  }

  removeItem(answer) {
    let index = this.products.indexOf(answer.value);
    if (index > -1) {
      this.products.splice(index, 1);
    }
    index = this.productCats.indexOf(answer.cats);
    if (index > -1) {
      this.productCats.splice(index, 1);
    }
  }

  handleDone() {
    if (this.state.selected > 0) {
      this.setState({ finished: true });

      if (this.state.selected !== 4) {
        this.productsStr = this.products[0].replace(",", ", ");
        this.props.triggerNextStep({
          value: this.productCats[0] + ":" + this.state.selected.toString(),
          message: this.productsStr
        });
      } else {
        this.productsStr = this.products.join(", ");
        this.props.triggerNextStep({
          value:
            this.productCats.join(", ") + ":" + this.state.selected.toString(),
          message: this.productsStr
        });
      }

    }
  }

  renderProducts() {
    const touchsupport = util.isMobile(navigator.userAgent);
    return (
      <div
        className={
          !touchsupport
            ? "container quiz-products"
            : "container quiz-products nohover"
        }
      >
        <div
          onClick={touchsupport ? this.handleInfoModal : null}
          className="quiz-products__info-hover"
        >
          What does each step mean?
        </div>
        <div className="quiz-products__info-window">
          <AthOnboardingProductsInfoWindow />
        </div>
        <div className="quiz-products__products">
          <div
            className={
              this.state.selected === 1
                ? "quiz-products-section selected"
                : "quiz-products-section"
            }
            onClick={() => this.handleOnClick(1)}
          >
            <div className="title">3-Step Regimen</div>
            <hr />
            <div className="incl-products">Wash, condition, dry</div>
          </div>
          <div
            className={
              this.state.selected === 2
                ? "quiz-products-section selected"
                : "quiz-products-section"
            }
            onClick={() => this.handleOnClick(2)}
          >
            <div className="title">4-Step Regimen</div>
            <hr />
            <div className="incl-products">Wash, condition, dry, style</div>
          </div>
          <div
            className={
              this.state.selected === 3
                ? "quiz-products-section selected"
                : "quiz-products-section"
            }
            onClick={() => this.handleOnClick(3)}
          >
            <div className="title">5-Step Regimen</div>
            <hr />
            <div className="incl-products">
              Wash, condition, dry, style, refresh
            </div>
          </div>
          <div
            className={
              this.state.selected === 4
                ? "quiz-products-section custom selected"
                : "quiz-products-section custom"
            }
            onClick={() => this.handleOnClick(4)}
          >
            <div className="title">Create Your Own</div>
            <hr />
            <AthOnboardingProductsBuild
              addItem={this.addItem}
              removeItem={this.removeItem}
              notSelected={this.state.selected !== 4}
              products={this.products}
            />
          </div>
          <div
            className={
              this.state.selected === 5
                ? "quiz-products-section selected"
                : "quiz-products-section"
            }
            onClick={() => this.handleOnClick(5)}
          >
            <div className="title">I don't know</div>
            <hr />
            <div className="incl-products">
              Don’t worry. We will choose the optimal routine based on your
              needs.
            </div>
          </div>
        </div>
        <div
          className={
            this.state.selected === 1 ||
            this.state.selected === 2 ||
            (this.state.selected === 3 || this.state.selected === 5) ||
            (this.state.selected === 4 && this.products.length > 0)
              ? "multiselect-component__selectable done-button"
              : "hide-me"
          }
          onClick={this.handleDone}
        >
          <div className="multiselect-component__label">
            <div className="multiselect-component__image-wrapper-btn">Done</div>
            <div className="multiselect-component__text">
              <div className="multiselect-component__title" />
            </div>
          </div>
        </div>
        <Modal
          open={this.state.showInfoModal}
          little
          onClose={this.onCloseInfoModal}
          closeOnOverlayClick={false}
          classNames={{
            overlay: "ha-overlay",
            modal: "ha-modal ath-info-modal"
          }}
        >
          <div className="ath-info-modal-body">
            <AthOnboardingProductsInfoWindow />
          </div>
        </Modal>
      </div>
    );
  }

  handleInfoModal = () => {
    this.setState({ showInfoModal: true });
  };

  onCloseInfoModal = () => {
    this.setState({ showInfoModal: false });
  };

  render() {
    if (this.state.finished) {
      return (
        <div
          style={
            this.props.answerWidthCheck <= 812
              ? answerBubbleStyleMobile
              : answerBubbleStyle
          }
        >
          {this.productsStr}
        </div>
      );
    } else {
      return (
        <div
          style={{ margin: "1px auto", width: "100%" }}
          className={this.state.finished ? "rsc-ts sc-dnqmqq" : null}
        >
          {this.renderProducts()}
        </div>
      );
    }
  }
}

export default AthOnboardingProducts;



// WEBPACK FOOTER //
// ./src/ath/components/onboarding/AthOnboardingProducts.js